
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.098","height":"11.635"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2782","stroke":"#fff","stroke-linecap":"round"}},[_c('path',{attrs:{"data-name":"Subtraction 109","d":"M16.6 7.913v3.122a.1.1 0 01-.1.1H1a.5.5 0 01-.5-.5v-.72L1.914 8.5.5 7.086v-.172L1.914 5.5.5 4.086v-.172L1.914 2.5.5 1.086v-.085a.5.5 0 01.5-.5h15.5a.1.1 0 01.1.1v3.446h-.1a1.936 1.936 0 000 3.871h.1z","fill":"none","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Line 65","fill":"#6747d9","stroke-dasharray":"0.1 1.5","d":"M5.052 10.635V1"}})])])
          )
        }
      }
    